// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V21H23V3ZM16.75 11.9998L8.75 16.5V7.5L16.75 11.9998Z"}}]};

const PlayRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-rectangle-filled',
    ref,
    icon: element,
  },
));

PlayRectangleFilledIcon.displayName = 'PlayRectangleFilledIcon';

export default PlayRectangleFilledIcon;
